import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d1c1e95c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=d1c1e95c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c1e95c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1c1e95c')) {
      api.createRecord('d1c1e95c', component.options)
    } else {
      api.reload('d1c1e95c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d1c1e95c&scoped=true&", function () {
      api.rerender('d1c1e95c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/vacation-types/components/vacation-type-sidesheet/index.vue"
export default component.exports